import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Client } from '../../../entities-state/types';


@Component({
  selector: 'clients-selector',
  templateUrl: 'clients-selector.component.html',
  styleUrls: ['clients-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ClientsSelectorComponent {
  @Input() clients: Client[];
  @Input() selected: number[];
  @Output() selectedChange = new EventEmitter<number[]>();

  @Input() deselectedLabel = 'Not available in';
  @Input() selectedLabel = 'Available in';
  @Input() disabled = false;
  @Input() readonly?: boolean = false;

  leftSelection = new Set<number>();
  rightSelection = new Set<number>();

  toggleInLeftSelection = (regionId: number) => {
    if (this.leftSelection.has(regionId)) {
      this.leftSelection.delete(regionId);
    } else {
      this.leftSelection.add(regionId);
    }
  };

  toggleInRightSelection = (clientId: number) => {
    if (this.rightSelection.has(clientId)) {
      this.rightSelection.delete(clientId);
    } else {
      this.rightSelection.add(clientId);
    }
  };

  get notSelectedClients() {
    return this.clients?.filter(client => !this.selected.includes(client.id));
  }

  get selectedClients() {
    return this.clients?.filter(client => this.selected.includes(client.id));
  }

  select = () => {
    const newValue = [...this.selected, ...this.leftSelection];
    this.selectedChange.emit(newValue);
    this.leftSelection.clear();
  };

  deselect = () => {
    const newValue = this.selected.filter(id => !this.rightSelection.has(id));
    this.selectedChange.emit(newValue);
    this.rightSelection.clear();
  };

  selectAll = () => {
    const newValue = this.clients.map(client => client.id);
    this.selectedChange.emit(newValue);
    this.leftSelection.clear();
  };

  deselectAll = () => {
    this.selectedChange.emit([]);
    this.rightSelection.clear();
  };
}
